import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { memo } from 'react';
import { Box, styled } from '@mui/material';
import { ErrorBoundary } from 'shared/components/error-boundary';
const StubArea = styled(Box)(({ theme }) => ({
    background: theme.palette.background.default,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    height: '100%',
    gap: 2,
}));
export const Stub = memo(function Stub({ children }) {
    return (_jsx(ErrorBoundary, { children: _jsx(StubArea, { children: children }) }));
});
